import React, { useEffect, useState, useMemo } from 'react';

import { apiContainer } from '@vlabs/api-bindings';
import {
  Divider, Page, Breadcrumbs, Breadcrumb,
} from '@vlabs/uikit';
import cn from 'classnames';
import { useTranslation } from 'react-i18next';
import { useParams, generatePath } from 'react-router-dom';

import { routes } from '@vlapps/point/src/app/routes';

import { CrowdDetails } from './components/CrowdDetails';
import { EventDetailsRenderer } from './components/EventDetailsRenderer';
import st from './VideoAnalyticDetailsPage.module.sass';

export function VideoAnalyticDetailsPage() {
  const { t } = useTranslation();
  const { eventId } = useParams();
  const [event, setEvent] = useState(null);
  const [isAnalyticExists, setIsAnalyticExists] = useState(true);

  const fetchVideoAnalytic = async (id) => {
    try {
      const data = await apiContainer.lunaClient.generalEvents.get(id);
      setEvent(data);
    } catch (e) {
      if (e?.error_code === 23001) {
        setIsAnalyticExists(false);
        return;
      }
      throw e;
    }
  };

  useEffect(() => {
    fetchVideoAnalytic(eventId);
  }, [eventId]);

  const Component = useMemo(() => {
    if (!event) return null;

    switch (event?.event_type) {
      case 'crowd':
        return CrowdDetails;

      case 'fight':
      case 'facecover':
      case 'weapon':
      case 'bag':
      case 'lying':
      case 'handsup':
      case 'fall':
      case 'fire':
        // FIXME: возвращать сразу готовый компонент, при необходимости заменяя блоки
        // например, <BaseDetails event={event} scoreBlock={CrowdScoreBlock} />
        return EventDetailsRenderer;

      default:
        console.warn(`[VideoAnalyticDetailsPage] Unknown analytics type — ${event?.event_type}`);
        return null;
    }
  }, [event]);

  const breadcrumbs = (
    <Breadcrumbs>
      <Breadcrumb
        caption={t('video_analytics_archive')}
        href={generatePath(routes.videoAnalytics.archive)}
      />
      <Breadcrumb caption={t('videoAnalytics:details.event details')} />
    </Breadcrumbs>
  );

  return (
    <Page
      breadcrumbs={breadcrumbs}
      className={st.Root}
      title={t('videoAnalytics:details.event details')}
    >
      <Divider small />
      {!!isAnalyticExists && !!Component && <Component event={event} />}
      {!isAnalyticExists && (
        <div className={cn('NotFoundPage', st.PageMessage)}>
          {t('videoAnalytics:details.api.notFound', { eventId })}
        </div>
      )}
    </Page>
  );
}
